import React from 'react'
import NotaFiscal from './NotaFiscal';
import { realParaNumber } from '../../util/numberUtil';

export class NotasFiscais extends React.Component {
  calcularTotalPeso () {
    return this.props.notasFiscais.map(v => v.peso)
      .reduce((sum, current) => Number(sum) + Number(current));
  }

  calcularTotalVolume () {
    return this.props.notasFiscais.map(v => v.volume)
      .reduce((sum, current) => Number(sum) + Number(current));
  }

  calcularTotalValor () {
    return this.props.notasFiscais.map(v => realParaNumber(v.valor))
      .reduce((sum, current) => sum + current);
  }

  render () {
    if (this.props.notasFiscais && this.props.notasFiscais.length) {
      return (
        <React.Fragment>
          <table className="table table-striped table-sm table-bordered text-center">
            <thead>
            <tr>
              <td colSpan={5} className='text-center'>
                <strong>Notas Fiscais</strong>
              </td>
            </tr>
            <tr>
              <th scope="col" width={8}></th>
              <th scope="col">Número do documento</th>
              <th scope="col">Valor</th>
              <th scope="col">Volume</th>
              <th scope="col">Peso (KG)</th>
            </tr>
            </thead>
            <tbody>
            {this.props.notasFiscais.map((notaFiscal, index) => <NotaFiscal key={`nota-fiscal-${index}`}
                                                                            notaFiscal={notaFiscal} exibeRemover={this.props.exibeRemover}/>)
            }
            </tbody>
            <tfoot>
            <tr>
              <td colSpan={2}><strong>VALORES TOTAIS</strong></td>
              <td>{this.calcularTotalValor()
                .toLocaleString('pt-br', {
                  style: 'currency',
                  currency: 'BRL'
                })}</td>
              <td>{this.calcularTotalVolume()}</td>
              <td>{this.calcularTotalPeso()}</td>
            </tr>
            </tfoot>
          </table>
        </React.Fragment>
      )
    }
    return '';
  }
}

export default NotasFiscais
